import React from "react";
import { Table, Button } from "react-bootstrap";
import { motion } from "framer-motion";

interface Referral {
  id: string;
  name: string;
  email: string;
  joinedDate: string;
  referredOn: string;
  reward: string;
}

interface MyReferralsProps {
  referrals: Referral[];
  onInviteFriends?: () => void;
}

const MyReferrals: React.FC<MyReferralsProps> = ({ referrals, onInviteFriends }) => {
  return (
    <div className="my-referrals-content">
      {referrals.length === 0 ? (
        <motion.div
          className="no-referrals-enhanced"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h3 className="no-referrals-title">Invite Friends & Earn Rewards!</h3>

          <p className="no-referrals-description">
            Share the love and get rewarded! Invite your friends to join Gifts From Heaven
            and earn exclusive benefits when they sign up.
          </p>

          <div className="no-referrals-benefits">
            <div className="benefit-item">
              <div className="benefit-icon">✨</div>
              <span>Earn rewards for each successful referral</span>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🎁</div>
              <span>Help friends discover thoughtful gifting</span>
            </div>
            <div className="benefit-item">
              <div className="benefit-icon">🤝</div>
              <span>Build a giving community together</span>
            </div>
          </div>

          {onInviteFriends && (
            <Button
              className="invite-friends-cta-btn"
              size="lg"
              onClick={onInviteFriends}
            >
              Invite Friends Now
            </Button>
          )}

          <p className="no-referrals-note">
            Your unique referral link will be shared automatically when you invite friends
          </p>
        </motion.div>
      ) : (
        <div className="referrals-table-wrapper">
          <Table className="referrals-table" responsive>
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Joined Date</th>
                <th>Referred On</th>
                <th>Reward</th>
              </tr>
            </thead>
            <tbody>
              {referrals.map((referral) => (
                <tr key={referral.id}>
                  <td>{referral.name}</td>
                  <td>{referral.email}</td>
                  <td>{referral.joinedDate}</td>
                  <td>{referral.referredOn}</td>
                  <td>{referral.reward}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
    </div>
  );
};

export default MyReferrals;
